module.exports = __webpack_public_path__ + "static/img/840-11.095327e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/psLock/840/840-11.jpg
// module id = z9ZV
// module chunks = 0